import { useBookableResourcesQuery, useEventTypesQuery } from '../lib/Queries';
import Select from './Select';

const BookableResourcesSelect = ({
    value,
    label,
    onChange,
    inputClassName,
    id,
    className,
}) => {
    const { data } = useBookableResourcesQuery();

    const options = [];
    const typeDetails = {};
    (data || []).forEach(type => {
        options.push({ label: type.name, value: type.id });
        typeDetails[type.id] = type;
    });

    return (
        <Select
            label={label}
            className={className}
            id={id}
            options={options}
            value={value}
            onChange={id => {
                onChange(id, typeDetails[id]);
            }}
            inputClassName={inputClassName}
        />
    );
};

export default BookableResourcesSelect;
